export default {
  title: "Dotazník kurzu",
  message: "Informace, které poskytnete, nám pomohou přizpůsobit kurz vašim preferencím a vytvořit tak pro vás lepší zážitek.",
  buttons: {
    submit: "Začít kurz",
    cancel: "Zrušit",
  },
  success: "Vaše odpovědi byly zaznamenány, přejeme vám příjemný zážitek z kurzu!",
  errors: {
    loadFailed: "Nepodařilo se načíst formulář",
    submitFailed: "Nepodařilo se odeslat formulář",
  },
};
